module.exports = __webpack_public_path__ + "img/sand-dune-decal-28.e9a3b6b4.png";